function decodeHtmlCharCodes (str) {
  return str.replace(/(&#(\d+);)/g, function (match, capture, charCode) {
    return String.fromCharCode(charCode)
  })
}
export default function (value) {
  // if (!value && value !== 0) return ''
  const { currency_code: code, format, symbol } = window.config.currency
  const price = parseFloat(value).toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
  const decodedSymbol = decodeHtmlCharCodes(symbol)
  const result = format.replace('{price}', price).replace('{code}', code).replace('{symbol}', decodedSymbol)
  return result
}
